import { useState, useRef } from "react";

export const useFeedback = () => {
  const [copiedLocation, setCopiedLocation] = useState<string | null>(null);
  const [activeShelfIcon, setActiveShelfIcon] = useState<string | null>(null);

  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const shelfTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const showCopyFeedback = (location: string) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setCopiedLocation(location);
    timeoutRef.current = setTimeout(() => setCopiedLocation(null), 1000);
  };

  const showShelfFeedback = (location: string) => {
    if (shelfTimeoutRef.current) clearTimeout(shelfTimeoutRef.current);
    setActiveShelfIcon(location);
    shelfTimeoutRef.current = setTimeout(() => setActiveShelfIcon(null), 1000);
  };

  return {
    copiedLocation,
    activeShelfIcon,
    showCopyFeedback,
    showShelfFeedback
  };
};
